export default "__VITE_ASSET__C1nXt1Kr__"